import { Options } from '@angular-slider/ngx-slider';
import { Component, Inject, Input, OnInit } from '@angular/core';
import { FormArray, FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { GobalFunctionService } from 'src/app/core/services/gobal/gobal-function.service';

@Component({
  selector: 'lifedi-question-rating',
  templateUrl: './question-rating.component.html',
  styleUrls: ['./question-rating.component.scss']
})
export class QuestionRatingComponent implements OnInit {
  @Input() ratingForm: FormGroup;
  @Input() isEditValue: boolean;
  modalData: any;
  value: number;
  options: Options;

  ratingLength = [2, 3, 4, 5, 6, 7, 8, 9, 10, 11]

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    private fb: FormBuilder,
    private gbFunction: GobalFunctionService
  ) {
    this.modalData = data;
    // console.log(this.isEditValue);
    // console.log(this.modalData);
  }

  ngOnInit(): void {
    // console.log(this.isEditValue);
    // if (!this.isEditValue) {
    //   this.ratingForm.get('default').setValue(1);
    // } else {
    this.ratingForm.get('default').setValue(1);
    if (this.isEditValue) {
      // console.log(this.modalData);
      // console.log(this.ratingForm.value);
      for (let i = 0; i < this.modalData.value.VALUE[0].choices.length; i++) {
        this.ratingFormArray.push(
          this.fb.group({
            choice_id: [this.modalData.value.VALUE[0].choices[i].choice_id],
            choice_detail: [this.modalData.value.VALUE[0].choices[i].choice_detail]
          })
        )
      }
    }
  }

  addLength() {
    this.ratingFormArray.clear();

    if (this.ratingForm.value.length > 7) {
      for (let i = 0; i < 2; i++) {
        this.ratingFormArray.push(
          this.fb.group({
            choice_id: [i + 1],
            choice_detail: ['']
          })
        )
      }

      this.value = Math.ceil(this.ratingForm.value.length / 2);
      this.options = {
        floor: 1,
        ceil: this.ratingForm.value.length,
        step: 1,
        showTicks: true,
        showTicksValues: false
      }
    } else {
      for (let i = 0; i < this.ratingForm.value.length; i++) {
        this.ratingFormArray.push(
          this.fb.group({
            choice_id: [i + 1],
            choice_detail: ['']
          })
        )
      }
    }
  }

  get ratingFormArray(): FormArray {
    return this.ratingForm.get('choices') as FormArray;
  }

}
